import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthentication } from '../../modules/auth/AuthenticationProvider';
import { BACKEND_URL } from '../backend-url';
import { TRANSPORT_ORDER_FILES_PATH } from '../paths';

type UploadFilesToTransportOrderMutationType = {
    transportOrderId: string;
    files: Array<File>;
}

export const useUploadFilesToTransportOrderRepository = () => {
    const { getJwtToken } = useAuthentication();
    const queryClient = useQueryClient();

    const uploadFiles = useMutation({
        mutationFn: (variable: UploadFilesToTransportOrderMutationType) =>
            uploadFilesFunction(variable.transportOrderId, variable.files),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['transportOrders', 'files'] });
        },
    });

    const uploadFilesFunction = async (transportOrderId: string, files: Array<File>) => {
        const token = await getJwtToken();

        const formData = new FormData();

        // Append all files to the formData instance
        files.forEach((file) => {
            formData.append('files', file);
        });

        await fetch(`${BACKEND_URL}/${TRANSPORT_ORDER_FILES_PATH(transportOrderId)}`, {
            method: 'POST',
            body: formData,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    };

    return {
        uploadFiles: (variables: UploadFilesToTransportOrderMutationType) => uploadFiles.mutateAsync(variables),
    };
};